import React, { CSSProperties, useState } from "react";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import "./WheelSlider.scss";

interface WheelSliderProps {
  values: (string | number)[];
  initValueIndex?: number;
  horizontalAlignment?: CSSProperties["justifyContent"];
  containerClass?: string;
  handleChange?: (newValue: string | number) => void;
}

export default function WheelSlider({
  values,
  initValueIndex = 2,
  horizontalAlignment = "center",
  containerClass,
  handleChange = (newValue) => null,
}: WheelSliderProps) {
  const [activeSlide, setActiveSlide] = useState<number>(initValueIndex);

  const generatePosClassname = (slideIndex: number) => {
    let classname = "";
    switch (true) {
      case Math.abs(activeSlide - slideIndex) === 1:
        classname = "SecondSlideInView";
        break;
      case activeSlide === slideIndex:
        classname = "CurrentSlide";
    }
    return classname;
  };

  const [sliderRef] = useKeenSlider({
    vertical: true,
    mode: "free-snap",
    initial: initValueIndex,
    range: {
      min: 0,
      max: values.length - 1,
    },
    slides: {
      origin: "center",
      perView: 5,
    },
    created: (slider) => {
      const activeSlideIndex = slider.track.details.abs;
      handleChange(values[activeSlideIndex]);
    },
    slideChanged: (slider) => {
      const activeSlideIndex = slider.track.details.abs;
      setActiveSlide(activeSlideIndex);
      handleChange(values[activeSlideIndex]);
    },
  });

  return (
    <div ref={sliderRef} className={`keen-slider ${containerClass}`}>
      {values.map((value, index) => (
        <div
          key={value}
          className={`keen-slider__slide py-1 Grotesk ${generatePosClassname(
            index
          )}`}
          style={{
            justifyContent: horizontalAlignment,
          }}
        >
          {value}
        </div>
      ))}
    </div>
  );
}
